import { Fade } from "./Reveal";
import { LeadNum } from "./Bits";

export function About() {
  return (
    <section id="about">
      <LeadNum no="01" label="About" right="the short version" />
      <div className="about-wrap">
        <Fade className="about-lead">
          I build <span className="v">clean, thoughtful</span> software. Reliable,
          well-designed systems at the intersection of engineering, automation, and AI.
        </Fade>
        <div>
          <Fade className="about-col">
            <p>
              I'm a Computer Science student at the University of Toronto focused on
              building reliable, well-designed systems. I care a lot about clean
              architecture, performance, and developer experience.
            </p>
            <p>
              Right now I'm at C3G building cloud infrastructure for Bento, an
              open-source genomics platform, using Kubernetes, Docker, and Helm.
            </p>
          </Fade>
          <Fade className="about-facts">
            <div className="fact">
              <span className="k">Focus</span>
              <span className="vv">Software Eng · Full-Stack</span>
            </div>
            <div className="fact">
              <span className="k">Currently</span>
              <span className="vv">C3G · Bento (OSS)</span>
            </div>
            <div className="fact">
              <span className="k">Stack</span>
              <span className="vv">TS · React · Python · Docker</span>
            </div>
          </Fade>
        </div>
      </div>
    </section>
  );
}
